import { Observable } from "rxjs";

export const SearchEscapeCharacters = '-:[]';

export interface GlobalSearchService<TModel> {
  search(searchPhrase: string, useWildcard: boolean, take: number): Observable<TModel[]>;
}